<template>
  <div id="editTask">
    <!-- {{taskData}} -->
    <h3 class="text-center pt-5 text-info">Edit Task Form</h3>
    <div class="container">
      <div id="editTask-row" class="row justify-content-center align-items-center">
        <div id="editTask-column" class="col-md-6">
          <div id="editTask-box" class="col-md-12">
            <form id="editTask-form" class="form" v-on:submit.prevent="editTask">
              <h3 class="text-center text-info">Edit Task</h3>
              <div class="form-group">
                <label for="username" class="text-info">Title:</label>
                <br />
                <input type="hidden" :value="id">
                <input type="text" name="username" id="username" class="form-control" v-model="title" />
              </div>
              <div class="form-group">
                <label for="email" class="text-info">Description:</label>
                <br />
                <input type="text" name="email" id="email" class="form-control" v-model="description" />
              </div>
              <label class="text-info">Column Sekarang :</label>
              <select name="column" class="form-control" v-model="selected">
                <option v-for="(col,i) in column" :key="i" :value="columnId[i]">{{col}}</option>
              </select>
              <div class="form-group">
                  <br><br>
                <input type="submit" name="submit" class="btn btn-info btn-md" value="Save Task" />
                <a class="text-info" v-on:click="homePage()">Back to Home</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["columns","taskData"],
  data(){
      return{
          title:this.taskData.title,
          description:this.taskData.description,
          categoryId:this.taskData.categoryId,
          selected:this.taskData.categoryId,
          id:this.taskData.id,
      }
  },
  methods: {
    homePage() {
      this.$emit("homePage");
    },
    editTask(){
        let payload={
            title:this.title,
            description:this.description,
            categoryId:this.selected,
            id:this.id,
        }
        this.$emit('editTask',payload)
        console.log(this.selected)
    }

  },
  computed: {
    column() {
      let result = [];
      for (let i = 0; i < this.columns.length; i++) {
        result.push(this.columns[i].title);
      }
      return result;
    },
    columnId(){
        let result=[];
        for(let i=0;i<this.columns.length;i++){
            result.push(this.columns[i].id)
        }
        return result;
    }
  }
};
</script>

<style>
</style>